module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAsklEQVQoU4WPIQ7CQBBF/7RVW4HA4LgAkgMgSGoQOBAIEhR6dw6ApLNVaBIEdUjwvQJJr7K1Q9pQAopRk/kv8/8n/Bn61kVkDSBh5mt/7wAR2YUQSmNMC6BpmluapitmPneA994C2KpqTUQJgImqXpj5+LHw3meqen+/XjLzo907oCiKk6pOVfVJREMAIwC1c27fZ5iHECpjzCaO47G19iAiM2auflrkeb6IomjgnCv7Fi+jPEAJnBY6tgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/NotaryDetail/icon3.png
// module id = yec8
// module chunks = 1